import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

import Home from "./components/Home";
import Portfolio from "./components/Portfolio";
import About from "./components/About";
import SocialMedia from "./components/SocialMedia"

function App() {
  return (
    <Router>
      <Routes>
        <Route exact path="/" element={<Home/>} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/SocialMedia" element={<SocialMedia />}/>
        <Route path="/About" element={<About/>} />
      </Routes>
    </Router>
  );
}

export default App;
